/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable import/no-cycle */
/* eslint-disable react/require-default-props */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useStateContext } from '../contexts/ContextProvider';
import { AssociateSchedule, GMap, Heartbeat } from '.';

// Flip, FlipOrig,
import Events from './Events';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
const BasicTabs = () => {
  const navigate = useNavigate();
  let usr = localStorage.getItem('user');
  const [searchParams] = useSearchParams();
  let selectedOrg = localStorage.getItem('organization');
  if (!usr || !selectedOrg) {
    // Redirect
    navigate('/login?landing=associatescontrolcenter');
    return <p>Please login... </p>;
  }
  usr = JSON.parse(usr);
  selectedOrg = JSON.parse(selectedOrg);
  const [value, setValue] = React.useState(0);
  const [associateid, setAssociateId] = useState('');

  const [lat, setLatitude] = useState('0');
  const [lng, setLongitude] = useState('0');
  const [name, setName] = useState('');
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const { activeMenu } = useStateContext();
  useEffect(() => {
    const tab = Number(searchParams.get('tabNo'));
    if (tab) {
      setValue(tab);
    }
    const aid = searchParams.get('id');
    if (aid) {
      setAssociateId(aid);
    }
    const alat = searchParams.get('lat');
    if (alat) {
      setLatitude(alat);
    }
    const alng = searchParams.get('lng');
    if (alng) {
      setLongitude(alng);
    }
    const aname = searchParams.get('name');
    if (aname) {
      setName(aname);
    }
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="associate tabs"
          orientation={activeMenu ? 'horizontal' : 'vertical'}
          scrollButtons="auto"
          variant="scrollable"
        >
          {/* }
          <Tab label="Detail Card" {...a11yProps(0)} />
          <Tab label="Profile" {...a11yProps(1)} />
          */}
          <Tab label="Events" {...a11yProps(0)} />
          <Tab label="Location" {...a11yProps(1)} />
          <Tab label="Charts" {...a11yProps(2)} />
          <Tab label="Schedule" {...a11yProps(3)} />
        </Tabs>
      </Box>
      {/*
      <CustomTabPanel value={value} index={0}>
        <Flip />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <FlipOrig />
      </CustomTabPanel>
      */}
      <CustomTabPanel value={value} index={0}>
        <Events />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <GMap />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <Heartbeat props={{ _id: associateid, latlng: { latitude: lat, longitude: lng }, name }} />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <AssociateSchedule />
      </CustomTabPanel>
    </Box>
  );
};
export default BasicTabs;
